module.exports = __webpack_public_path__ + "static/media/event_expanded2.056402fd.png";